module.exports = __webpack_public_path__ + "951828870c046f7ca01ae4c4332384f8.jpg";